import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import { Tooltip } from 'react-bootstrap';

 /* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage.js';
/* Actions */
import * as flowAdminRcaReportsActions from '../../actions/flow_admin_rca_reports/index.js';
import * as dynamicListActions from '../../actions/dynamic_list';

/* Components */
import Header from '../../components/flow_admin_rca_reports/header';
import SecondHeader from '../../components/flow_admin_rca_reports/secondHeader';
import FlowsByScheduleHistogramGraph from '../../components/flow_admin_rca_reports/flowsByScheduleHistogramGraph';
import FlowsByCategoryTagsHistogramGraph from '../../components/flow_admin_rca_reports/flowsByCategoryTagsHistogramGraph';
import FlowsByVehicleTypeHistogramGraph from '../../components/flow_admin_rca_reports/flowsByVehicleTypeHistogramGraph';
import TitleMain from '../../components/common/titleMain';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class FlowAdminRcaReports extends Component {
	constructor(props) {
		super(props);
	    this.state = {
			listsByName: {}
		};
	}

	componentWillUnmount() {
    	this.props.actions.resetFlowAdminRcaReports();
  	}

	async componentDidMount() {
	    const permits = localStoreFN().getItem('permits');
	    const permit = permits.includes('flowrequestsadmin');

	    if (permit) {
	      if (this.props.setting) {
	        const obj = JSON.parse(this.props.setting.value);
	        if (obj.generalSetting.views.includes('flowrequests')) {
		      const dateStart = this.props.filters.date.fechaStartFinal || null;
		      const dateEnd = this.props.filters.date.fechaEndFinal || null;
		      const tags = this.props.filters.tags;
		      const vehicleType = this.props.filters.vehicleType || null;
		      const direction = this.props.filters.direction || null;
		      const status = this.props.filters.status || null;

		      await this.props.dynamicListActions.getAllListWithItems({});
		      await this.props.actions.fetchFlowAdminRcaReportsApi({
		        dateStart,
		        dateEnd,
		        tags,
		        vehicleType,
		        direction,
		        status
		      });
		    } else {
		      this.props.history.push('/dashboard/authorization');
		    }
		  }
		} else {
		  this.props.history.push('/dashboard/authorization');
		}
	}

  	//Manage redux state changes
  	async componentDidUpdate(prevProps) {
	    if (prevProps.lists.loading == true 
	      && this.props.lists.loading == false
	      && this.props.lists.status === 200) {      
	      this.props.lists.datos.map((item) => {
	        this.state.listsByName[item.name.toUpperCase()] = item;
	      });
	    }
	};

	handleSubmit = async obj => {
		/* GROUP */
		const objDate = JSON.parse(this.props.setting.value);
		const format = this.props.language.account.date.format;
		/* TAGS */
		const tags = ObjGeneral.getTags(obj);
		/* DATE */
		const date = ObjGeneral.getDate(obj, format);
	    /*VEHICLE TYPE*/
	    const vehicleType = ObjGeneral.getFlowVehicleType(obj);
	    /*DIRECTION*/
	    const direction = ObjGeneral.getFlowDirection(obj);
	    /*STATUS*/
	    const status = ObjGeneral.getFlowStatus(obj);

		this.props.actions.setFilterFlowAdminRcaReports({
		  tags: tags,
		  date: date,
		  vehicleType: vehicleType,
  		  direction: direction,
  		  status: status
		});
		await this.props.actions.fetchFlowAdminRcaReportsApi({
		  tags: tags,
		  dateStart: date.fechaStartFinal,
		  dateEnd: date.fechaEndFinal,
		  vehicleType: vehicleType,
  		  direction: direction,
  		  status: status
		});
	};

	handleExportExcel = async obj => {
		const dateStart = this.props.filters.date.fechaStartFinal || null;
		const dateEnd = this.props.filters.date.fechaEndFinal || null;
		const tags = this.props.filters.tags;
		const vehicleType = this.props.filters.vehicleType || null;
		const direction = this.props.filters.direction || null;
		const status = this.props.filters.status || null;

		await this.props.actions.downloadExcelStats({
			dateStart,
			dateEnd,
			tags,
			vehicleType,
			direction,
			status
		});
	};

	handleExportExcelCharts = async obj => {
		const dateStart = this.props.filters.date.fechaStartFinal || null;
		const dateEnd = this.props.filters.date.fechaEndFinal || null;
		const tags = this.props.filters.tags;
		const vehicleType = this.props.filters.vehicleType || null;
		const direction = this.props.filters.direction || null;
		const status = this.props.filters.status || null;

		await this.props.actions.downloadExcelCharts({
			dateStart,
			dateEnd,
			tags,
			vehicleType,
			direction,
			status
		});
	};

	render() {
	    if (this.props.setting) {
	      const obj = JSON.parse(this.props.setting.value);
	      const setting = ObjGeneral.getSetting({
	        setting: obj.flowAdminRcaReports,
	        filter: this.props.filter,
	        general: obj.generalSetting
	      });

	      const { graphColorRange } = obj;
	      let language = this.props.language ? this.props.language.filter : '';
          var  flowRequestCategory = null;
          var  flowRequestCategoryTags = [];

	      if(obj.flowRequestSettings 
	        && obj.flowRequestSettings.flowRequestCategory) {
	        flowRequestCategory = obj.flowRequestSettings.flowRequestCategory;
			setting.filter.map((item, i) => {
        		if(item.name && flowRequestCategory!=null 
          			&& item.name.toUpperCase()==flowRequestCategory.toUpperCase()) {
					flowRequestCategoryTags = item.tags;
        		}	
    		});    
	      }

	      return (
	        <section className="main full-height flow-admin-rca-reports">
	          {(this.props.loading
	          	|| this.props.lists.loading
	          	|| this.props.loadingFilter) ? (
	            <Loading language={this.props.language} />
	          ) : (this.props.status === 401 
	          	|| this.props.statusTags === 401
	          	|| this.props.lists.status == 401) ? (
	            <Expired
	              history={this.props.history}
	              language={this.props.language ? this.props.language : ''}
	            />
	          ) : (this.props.status === 200 
	          	&& this.props.statusTags === 200	          	
	          	&& this.props.lists.status == 200) ? (
				<div>
					<Header
						language={language}
						loadingFilter={this.props.loadingFilter}
						filters={this.props.filters}
						filter={setting.filter}
						datos={this.props.datos}
						handleSubmit={this.handleSubmit}
						flowRequestCategory={flowRequestCategory}
					/>
		            <div className="main-container">
                      <div className="second-header-filters">
						<SecondHeader
							language={this.props.language}
							handleSubmit={this.handleSubmit}
							filters={this.props.filters}
							exportExcel={this.handleExportExcel}
							exportExcelCharts={this.handleExportExcelCharts}
							lists={this.state.listsByName}
						/>
		              </div>
		              <div className="main-col">
		                <section className="histogram-by-schedule">
		                  <TitleMain
		                    title={"Flujo por horario"}
		                  />
		                  <FlowsByScheduleHistogramGraph
		                    data={this.props.datos.histogramFlowsBySchedule}
		                  />
		                </section>
		                <section className="histogram-by-category-tags">
		                  <TitleMain
		                    title={"Flujo por transportistas"}
		                  />
		                  {flowRequestCategoryTags.length>0 && (
			                  <FlowsByCategoryTagsHistogramGraph
			                    data={this.props.datos.histogramFlowsByCategoryTags}
			                    labels={flowRequestCategoryTags}
		                      />
	                      )}
		                </section>
		                <section className="histogram-by-vehicle-type">
		                  <TitleMain
		                    title={"Flujo por tipo de vehículo"}
		                  />
		                  {this.state.listsByName["VEHICLE TYPE"] &&
		                  this.state.listsByName["VEHICLE TYPE"].items.length>0 && (
			                  <FlowsByVehicleTypeHistogramGraph
			                    data={this.props.datos.histogramFlowsByVehicleType}
								labels={this.state.listsByName["VEHICLE TYPE"]}
			                  />
		                  )}
		                </section>
		              </div>
		              <Tooltip placement="top" id="pageTooltip" />
		            </div>
	            </div>
	          ) : (this.props.status === 500 
	          	|| this.props.statusTags === 500
	          	|| this.props.lists.status === 500) ? (
	            <Message message={this.props.language.error.apiError500} />
	          ) : (
	            <Message message={this.props.language.error.apiError} />
	          )}
	        </section>
	      );
	    } else {
	      return (
	        <section className="main">
	          <Message message="NO Setting" />
	        </section>
	      );
	    }
	}
}
const mapStateToProps = state => ({
	filter: state.reducer.tags.filter,
	statusTags: state.reducer.tags.status,
	loadingFilter: state.reducer.tags.loading,

	language: state.reducer.dashboard.language,
	dateMax: state.reducer.dashboard.dateMax,
	setting: state.reducer.dashboard.setting,
	datos: state.reducer.flowAdminRcaReports.datos,
	loading: state.reducer.flowAdminRcaReports.loading,
	status: state.reducer.flowAdminRcaReports.status,
	filters: state.reducer.flowAdminRcaReports.filters,

	lists: state.reducer.dynamicList.lists,
 });
const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(flowAdminRcaReportsActions, dispatch),
	dynamicListActions: bindActionCreators(dynamicListActions, dispatch)
});
FlowAdminRcaReports.propTypes = {

};

export default connect(mapStateToProps,mapDispatchToProps)(FlowAdminRcaReports);


// WEBPACK FOOTER //
// ./source/client/containers/flow_admin_rca_reports/index.jsx